import React, { useState } from 'react';
import { useAssets, useUser } from 'hooks';

import { Form } from 'form/form/Form';
import { AssetStatuses } from 'hooks/useAssets/useAssets.types';
import { ProxyMetadata } from 'hooks/useAssets/useAssets.types';
import { useIam } from 'api/hooks/useIam/useIam';

import { ActivateAsset } from './ActivateAsset';

export const ActivateAssetContainer = () => {
  const { updateToken, getAllTokens } = useIam();
  const { setAssetsFromClaims, getAssetById } = useAssets();
  const { user } = useUser();
  const [isLoading, setLoading] = useState<boolean>(false);

  const onSubmit = async (values: Record<string, string>) => {
    setLoading(true);

    if (!values.id) {
      setLoading(false);
      return;
    }

    const asset = getAssetById(values.id);
    await updateToken({
      ...asset?.originalData,
      ...values,
      status: AssetStatuses.ACTIVE,
      dateOfRegistration: new Date().toISOString(),
      owner: user && {
        name: user.name,
        address: user.address,
      },
    });
    const claims = await getAllTokens();
    setAssetsFromClaims(claims as ProxyMetadata[]);
    setLoading(false);
  };

  return (
    <Form shouldUnregister={false}>
      {({ handleSubmit }) => <ActivateAsset isLoading={isLoading} onSubmit={handleSubmit(onSubmit)} />}
    </Form>
  );
};
